export default __webpack_public_path__ + "static/media/Prompts and Notifications API Portal.d9e4142c.png";